import Immutable from 'immutable';
import { getAppServices } from 'providers/app-services';
import { AppState, AppStateActionParams } from 'records/AppState';
import { Doc } from 'records/Doc';
import {
  BatchUploadProgress,
  DocumentUploadProgress,
} from 'records/UploadProgress';
import {
  deleteDocumentsFailedToProcess,
  getDocumentsByProcessingRequest,
} from 'services/documentService';

export interface UploadActions {
  updateActiveUploads: (
    actionParams: AppStateActionParams,
    upload: BatchUploadProgress
  ) => AppState;
  removeActiveUpload: (
    actionParams: AppStateActionParams,
    id: string
  ) => AppState;
  getRecentUploads: (actionParams: AppStateActionParams) => Promise<AppState>;
  clearRecentDocumentErrors: (
    actionParams: AppStateActionParams,
    documentIds: string[]
  ) => Promise<AppState>;
  addCancelationRequest: (
    actionParams: AppStateActionParams,
    documentId: string
  ) => AppState;
  removeCancelationRequest: (
    actionParams: AppStateActionParams,
    documentId: string
  ) => AppState;
}

const uploadActions: UploadActions = {
  updateActiveUploads: (
    { state }: AppStateActionParams,
    upload: BatchUploadProgress
  ): AppState => {
    return state().setIn(['activeUploads', upload.processingRequestId], upload);
  },
  removeActiveUpload: (
    { state }: AppStateActionParams,
    id: string
  ): AppState => {
    return state().removeIn(['activeUploads', id]);
  },
  getRecentUploads: async ({
    state,
    actions,
  }: AppStateActionParams): Promise<AppState> => {
    const now = new Date();
    const refTime = now.setHours(new Date().getHours() - 2);
    if (state().processingStatuses.count() === 0) {
      await actions.getProcessingStatuses();
    }
    const { authService } = getAppServices();
    const currentUserEmail = authService.getCredentials().email.toLowerCase();
    const filteredPS = Array.from(state().processingStatuses.values()).filter(
      (ps) => {
        const uploadDate = new Date(ps.uploadTimestamp * 1000);
        return (
          uploadDate.valueOf() > refTime &&
          ps.status !== 'Uploading' &&
          ps.uploadedBy === currentUserEmail
        );
      }
    );

    const docList = await Promise.all(
      filteredPS.map((d) =>
        getDocumentsByProcessingRequest(d.processingRequestid)
      )
    );
    let newRecentUploads = Immutable.OrderedMap<string, BatchUploadProgress>();
    docList.map((dl) => {
      const requestId = dl.first(new Doc()).processrequestid;
      newRecentUploads = newRecentUploads.set(
        requestId,
        new BatchUploadProgress(
          0,
          0,
          requestId,
          dl
            .map((d) => {
              return {
                title: d.filename,
                id: d.documentid,
                totalToUpload: d.filesize,
                totalUploaded: d.filesize,
                error: d.error,
              } as DocumentUploadProgress;
            })
            .toArray()
        )
      );
    });
    // if (newRecentUploads.filter(nru => nru.documentsProgress(d => d.)))
    return state().set('recentUploads', newRecentUploads);
  },
  clearRecentDocumentErrors: async (
    { state }: AppStateActionParams,
    documentIds: string[]
  ): Promise<AppState> => {
    console.log(documentIds);
    await deleteDocumentsFailedToProcess(state().selectedProject, documentIds);
    return state();
  },
  addCancelationRequest: (
    { state }: AppStateActionParams,
    documentId: string
  ): AppState => {
    return state().set(
      'uploadCancelationRequests',
      state().uploadCancelationRequests.push(documentId)
    );
  },

  removeCancelationRequest: (
    { state }: AppStateActionParams,
    documentId: string
  ): AppState => {
    return state().removeIn(['uploadCancelationRequests', documentId]);
  },
};

export default uploadActions;
